// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import type { CmsSubscribe } from 'api/cms';
import { postJson } from 'utils/http';
import RichError from 'utils/RichError';
import trackError from 'utils/trackError';
import type { Location } from 'react-router';
import { showModal as showModalRaw } from '../redux/main/actions/modal';
import useTemporaryStorage from '../utils/useTemporaryStorage';
import { getParam } from '../utils/url';

const { useState, useEffect, useCallback } = React;

type OwnProps = {
  blockId: string,
  index: number,
  render: ({
    subscribe: () => void,
    isSubscribed: boolean
  }) => React.Node,
  location: Location
};

type Props = {
  ...$Exact<OwnProps>,
  currentUser: Object,
  showModal: typeof showModalRaw,
  tmpId: ?string
};

const CmsSubscribeContainer = (props: Props) => {
  const [disabled, setDisabled] = useState(false);
  const [tmpId, setTmpId] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const [saveTemporaryStorage, temporaryStorage] = useTemporaryStorage<
    $Exact<CmsSubscribe>
  >(props.tmpId);

  const subscribe = useCallback(
    () => {
      const { currentUser } = props;

      const showEmailSignupModal = (tmpIdToUse: string) => {
        const redirectTo = `${window.location.pathname}${
          window.location.search ? '&' : '?'
        }tmpId=${tmpIdToUse}`;
        props.showModal('EMAIL_SIGNUP', {
          title: getText('Create an account on Idealist in order to subscribe'),
          redirectTo
        });
      };

      const loggedInVerifiedWithInfo = !!(
        currentUser &&
        currentUser.email !== null &&
        currentUser.emailVerified &&
        currentUser.firstName &&
        currentUser.lastName
      );

      if (loggedInVerifiedWithInfo) {
        const postBaseUrl = '/data/website/button-link-campaign-signup/';
        postJson(postBaseUrl + props.blockId, { index: props.index })
          .then(() => {
            setIsSubscribed(true);
          })
          .catch(e => {
            trackError(
              new RichError('Error subscribing in CMS block', JSON.stringify(e))
            );
          });
      } else {
        if (!disabled && !tmpId) {
          setDisabled(true);
          saveTemporaryStorage({
            CMS_SUBSCRIBE: { blockId: props.blockId, index: props.index }
          }).then(createdTmpId => {
            setDisabled(false);
            setTmpId(createdTmpId);
            return showEmailSignupModal(createdTmpId);
          });
        }

        showEmailSignupModal(tmpId);
      }
    },
    [disabled, props, saveTemporaryStorage, tmpId]
  );

  useEffect(
    () => {
      if (
        temporaryStorage.blockId === props.blockId &&
        temporaryStorage.index === props.index &&
        props.currentUser.emailVerified
      ) {
        subscribe();
      }
    },
    [
      props.blockId,
      props.currentUser.emailVerified,
      props.index,
      subscribe,
      temporaryStorage
    ]
  );
  return props.render({
    subscribe: subscribe.bind(this),
    isSubscribed
  });
};

const mapStateToProps = ({ currentUser }, { location }) => ({
  currentUser,
  tmpId: getParam(location, 'tmpId')
});

export default withRouter(
  connect(
    mapStateToProps,
    { showModal: showModalRaw }
  )(CmsSubscribeContainer)
);
